export const gallerySectionCommercialExteriorPainting =
{
    "title": "Explore Our Work",
    "columns": 3,
    "rowHeight": 1200,
    "pageSize": 9,
    "images": [
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/1.jpg", "rowSpan": 2, "colSpan": 1 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/2.jpg", "rowSpan": 1, "colSpan": 2 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/3.jpg", "rowSpan": 2, "colSpan": 2 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/4.jpg", "rowSpan": 1, "colSpan": 1 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/5.jpg", "rowSpan": 2, "colSpan": 1 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/6.jpg", "rowSpan": 1, "colSpan": 2 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/7.jpg", "rowSpan": 2, "colSpan": 2 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/8.jpg", "rowSpan": 1, "colSpan": 1 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/9.jpg", "rowSpan": 2, "colSpan": 1 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/10.jpg", "rowSpan": 1, "colSpan": 2 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/11.jpg", "rowSpan": 2, "colSpan": 2 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/12.jpg", "rowSpan": 1, "colSpan": 1 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/13.jpg", "rowSpan": 2, "colSpan": 1 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/14.jpg", "rowSpan": 1, "colSpan": 2 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/15.jpg", "rowSpan": 2, "colSpan": 2 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/16.jpg", "rowSpan": 1, "colSpan": 1 },
        { "src": "/assets/imgs/services/0003CommercialExteriorPainting/17.jpg", "rowSpan": 2, "colSpan": 1 }
    ]

}